import styled, { css } from "styled-components";

interface TextProps {
  fontFamily?: 'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp';
  fontSize?: string | number;
  fontWeight?: string | number;
  lineHeight?: string | number;
  letterSpacing?: string;
  color?: string;
}

export const getRecapFontFamily = (fontFamily?: string) => {
  switch (fontFamily) {
    case 'pp':
      return css`font-family: 'PP Neue Montreal', sans-serif;`;
    case 'plain':
      return css`font-family: 'Plain', sans-serif;`;
    case 'fifties-cond-med':
      return css`font-family: 'VVDS Fifties Cond Med', sans-serif;`;
    case 'basis':
      return css`font-family: 'Basis Grotesque Mono', sans-serif;margin-bottom: -3px;`;
    case 'maison-neue':
    default:
      return css`font-family: 'Maison Neue', sans-serif;`;
  }
};

const getLineHeightDefault = (fontFamily?: string) => {
  switch (fontFamily) {
    case 'basis':
      return 0.8;
    // case 'fifties-cond-med':
    //   return 0.75;
    default:
      return 1;
  }
};

export const Text = styled.p<TextProps>`
  font-size: ${props => props.fontSize || '20px'};
  font-weight: ${props => props.fontWeight || '400'};
  line-height: ${props => props.lineHeight || getLineHeightDefault(props.fontFamily)};
  letter-spacing: ${props => props.letterSpacing || 'normal'};
  color: ${props => props.color || '#ffffff'};
  margin-bottom: 0;
  text-transform: uppercase;
  ${props => getRecapFontFamily(props.fontFamily)}
`;

export default Text;